import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    static targets = ['trigger', 'short', 'full', 'target'];

    connect() {
        // Height-based expand (legacy targets)
        this.triggerTargets.forEach((trigger) => {
            if (this.hasShortTarget || this.hasFullTarget) {
                return;
            }

            trigger.addEventListener('click', () => {
                const expanded = trigger.classList.contains('trigger-expanded');

                if (expanded) {
                    trigger.classList.remove('trigger-expanded');
                    this.element.classList.remove('trigger-expanded');
                } else {
                    trigger.classList.add('trigger-expanded');
                    this.element.classList.add('trigger-expanded');
                }

                this.toggleHeight(expanded);
            });
        });

        if (this.element.classList.contains('trigger-expanded') && !this.hasShortTarget) {
            this.toggleHeight();
            this.triggerTargets.forEach((trigger) => {
                trigger.classList.add('trigger-expanded');
            });
        }
    }

    toggle(event) {
        event.preventDefault();

        if (!this.hasShortTarget || !this.hasFullTarget) {
            return;
        }

        const expanded = this.element.classList.toggle('is-expanded');

        this.shortTarget.classList.toggle('hidden', expanded);
        this.fullTarget.classList.toggle('hidden', !expanded);

        if (this.hasTriggerTarget) {
            const more = this.triggerTarget.dataset.labelMore || 'Read more';
            const less = this.triggerTarget.dataset.labelLess || 'Read less';
            this.triggerTarget.textContent = expanded ? less : more;
        }
    }

    toggleHeight(expanded = false) {
        this.targetTargets.forEach((target) => {
            let totalChildrenHeight = 0;
            if (!expanded) {
                for (const child of target.children) {
                    totalChildrenHeight += child.offsetHeight;
                    const computeStyle = window.getComputedStyle(child);
                    totalChildrenHeight += parseInt(computeStyle.getPropertyValue('margin-top'));
                    totalChildrenHeight += parseInt(computeStyle.getPropertyValue('margin-bottom'));
                }
            }

            target.style.height = `${totalChildrenHeight}px`;

            if (expanded) {
                target.classList.remove('target-expanded');
            } else {
                target.classList.add('target-expanded');
            }
        });
    }
}
